export { default as ForgotPasswordConfirmation } from './hocs';
